/**
 * Formattazione di default per le Valute (EUR).
 * Lo stile è quello predefinito per l'Italia.
 */
export const currencyNumberFormatter = new Intl.NumberFormat('it-IT', {
  currency: 'EUR',
  currencyDisplay: 'symbol',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: 'currency',
});
